let configApp = {
    routesNoAuth: [],
    default_foreign_key: {
        application_id: '81cb0181-348b-4990-8fc4-8bcfd0f3c763',
        application_instance_id: '013aee58-14f6-4f74-ada7-e95e8eadfcf9',
        application_profile_id: '873a904f-00a7-4d0b-a015-af668203e26a',
        profiles: {
            admin: '873a904f-00a7-4d0b-a015-af668203e26a',
            admin_gci: '8dac7fe9-a67b-42fd-ae66-81d770eb4540',
            business_manager: 'f1acd9b3-a53a-411d-b018-2c32379dd193',
            business_assistant: '776c7556-0ef4-4646-a967-95f8d489cd0c',
            project_manager: '8f41032c-699a-4fce-b57a-0df5799c60e0',
            seller: '3553b680-ab51-4d57-8dc4-2da7ba690203'
        },
        gci_revenue_types:{
            sale_revenue: '11a0e710-a33c-440f-8986-8b60183c865a',
            service_contract_revenue: 'c3b1f6e2-5a4d-4f0b-9d7e-2a8e6c1b9f43'
        }
    }
}
export default configApp;